module.exports = __webpack_public_path__ + "static/media/dotAudit.479da011.svg";